<script>
import { relatedPetition } from '../api/petitions';
import { relatedCrowdpac } from '../api/crowdpacs';
import { blogsRelated } from '../api/blogs';
import { newsRelated } from '../api/news';

export default {
    name: 'CpRelatedPosts',
    components: {
        CpBox: require('../box').default,
        CpBoxContent: require('../box-content').default,
        CpGrid: require('../grid').default,
        CpGridItem: require('../grid-item').default,
        CpButton: require('../button').default,
        CpPageContent: require('../page-content.vue').default,
        CpImage: require('../image.vue').default,
        CpIcon: require('../icon').default,
        CpButtonLink: require('../button-link').default,
        CpTagIcon: require('../tags/icon').default,
        VueSimpleSpinner: require('../vue-simple-spinner').default,
        CpBaseSvgIcon: require('../base-svg-icon').default,
        BlogDefaultIcon: require('../social-feed/icons/blog-default').default,
    },
    props: {
        post: [Object, Number],
        type: String,
    },
    data() {
        return {
            relatedPosts: [],
            loadingRelatedPosts: true,
            appUrl: process.env.MIX_APP_URL,
        }
    },
    mounted() {
        if (this.type == 'petition') {
            relatedPetition(this.post.id)
                .then((response) => {
                    this.relatedPosts = response.petitions_related;
                    this.loadingRelatedPosts = false;
                })
                .catch((error) => {
                    this.loadingRelatedPosts = false;
                    console.warn(error);
                });
        } else if (this.type == 'crowdpac') {
            relatedCrowdpac(this.post)
                .then((response) => {
                    this.relatedPosts = response.crowdpacs_related;
                    this.loadingRelatedPosts = false;
                })
                .catch((error) => {
                    this.loadingRelatedPosts = false;
                    console.warn(error);
                });
        } else if (this.type == 'blog') {
            blogsRelated(this.post.id)
                .then((response) => {
                    this.relatedPosts = response.blogs_related;
                    this.loadingRelatedPosts = false;
                })
                .catch((error) => {
                    this.loadingRelatedPosts = false;
                    console.warn(error);
                });
        } else if (this.type == 'news') {
            newsRelated(this.post.id)
                .then((response) => {
                    this.relatedPosts = response.news_related;
                    this.loadingRelatedPosts = false;
                })
                .catch((error) => {
                    this.loadingRelatedPosts = false;
                    console.warn(error);
                });
        }
    },
    methods: {
        postPermalink(item) {
            return this.type == 'petition'
                ? `${this.appUrl}/petitions/${item.id}?ref_code=social-feed`
                : this.type == 'blog'
                    ? '/blogs/' + item.id
                    : this.type == 'news'
                        ? '/news/' + item.id
                        : item.permalink;
        },
        imageAltUrl(event) {
            event.target.src = 'https://res.cloudinary.com/crowdpac/image/upload/v1596929923/social-feed/news-default-bg.png';
        },
    }
};
</script>

<template>
    <div class="box-related">
        <h2 v-if="type == 'crowdpac'" class="title-post-related">Popular Campaigns on CrowdBlue</h2>
        <h2 v-else-if="type == 'petition'" class="title-post-related">Other Popular Petitions on CrowdBlue</h2>
        <h2 v-else class="title-post-related">What Other Members Are Reading</h2>

        <div v-if="loadingRelatedPosts" class="heading-4" style="text-align: center; margin-bottom: 20px;">
            <vue-simple-spinner />Loading...
        </div>
        <cp-grid v-else-if="!loadingRelatedPosts && relatedPosts.length">
            <cp-grid-item
                :span="($root.isMobile && !$root.isTablet) || ($root.isMobile && $root.isTablet) ? 12 : 4"
                v-for="(item, index) in relatedPosts"
                :key="item.id"
                style="display: block; margin-bottom: 30px;"
            >
                <div style="border: 1px solid #ddd; padding: 10px; height: 100%;">
                    <a :href="postPermalink(item)" style="text-decoration: none; color: black;">
                        <div style="text-align: center" class="social-feed-post-profile-wrapper">
                            <img v-if="item.image && type != 'news'" :src="item.image" class="image" />
                            <img v-else-if="item.image && type == 'news'" :src="item.image" class="social-feed-post-img image-news-related" @error="imageAltUrl"/>
                            <img v-else-if="!item.image && type == 'news'" :src="'https://res.cloudinary.com/crowdpac/image/upload/v1596929923/social-feed/news-default-bg.png'" class="social-feed-post-img image-news-related" @error="imageAltUrl"/>
                            <cp-base-svg-icon
                                v-else-if="!item.image && type == 'blog'"
                                :width="'100%'"
                                :height="'100%'"
                                :viewBox="'0 0 558 332'"
                                :icon-color="'none'"
                                :stroke-color="'none'"
                                class="image"
                            >
                                <blog-default-icon/>
                            </cp-base-svg-icon>
                        </div>
                        <div style="height: 50px;">
                            <h3 class="name-post-related">{{ type == 'news' ? item.title : item.name }}</h3>
                        </div>
                        <div v-if="type != 'news'">
                            <div v-if="item.tags.length && (!$root.isMobile && !$root.isTablet)">
                                <cp-grid stretch-content v-if="item.tags.length == 1">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="12" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 2">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 3">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="indexTag == 2 ? 12 : 6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 4">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 5">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="indexTag == 4 ? 12 : 6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                            </div>
                            <div v-if="(item.tags.length && (!$root.isMobile && $root.isTablet)) || (item.tags.length && ($root.isMobile && $root.isTablet))">
                                <cp-grid stretch-content v-if="item.tags.length == 1">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="12" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 2">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 3">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="indexTag == 2 ? 12 : 6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 4">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 5">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="indexTag == 4 ? 12 : 6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag font-post-tag-related">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                            </div>
                            <div v-if="(item.tags.length && ($root.isMobile && !$root.isTablet))">
                                <cp-grid stretch-content v-if="item.tags.length == 1">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="12" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 2 || item.tags.length == 4">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 3">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="indexTag == 2 ? 12 : 6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                                <cp-grid stretch-content v-else-if="item.tags.length == 5">
                                    <cp-grid-item v-for="(tag, indexTag) in item.tags" :key="tag.name" :span="indexTag == 4 ? 12 : 6" class="post-tag-mobile">
                                        <cp-button :tag="true" class="post-tag">
                                          <cp-tag-icon :tag="tag.name" />
                                        </cp-button>
                                    </cp-grid-item>
                                </cp-grid stretch-content>
                            </div>
                        </div>
                    </a>
                </div>
            </cp-grid-item>
        </cp-grid>
    </div>
</template>
<style>
.image-news-related {
    border-radius: 5px;
    max-width: 100%;
    width: 100%;
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
    margin: 0px 0px 0px 0px;
    min-height: 300px;
    max-height: 300px;
    object-fit: cover;
}
.box-related {
    margin: 30px 0 0;
}
.title-post-related {
    font-size: 30px;
    text-align: center;
    margin-bottom: 20px;
    font-family: var(--sans-font);
    color: black;
    font-weight: bold;;
}
.loading {
    margin: 0 5px;
}
.name-post-related {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 18px;
    font-family: var(--sans-font);
    color: black;
    margin-top: 15px;
    font-weight: bold;
}
.post-tag-mobile {
    margin-top: 0;
    margin-bottom: 0;
}
.box-tags {
    width: 50%;
    justify-content: center;
    margin: 10px auto 20px;
    display: flex;
    flex-wrap: wrap;
}
.post-tag {
    background: none;
    border: none;
    font-size: 16px;
    cursor: auto!important;

}
.font-post-tag-related {
    font-size: 14px;
    cursor: pointer!important;
}
.title-1 {
    text-align: center;
    margin: 20px 0px 0px 0px;
}
.heading-2 {
    text-align: left;
    font-size: 18px;
    color: #121212;
    line-height: 1.5;
    font-family: "proxima-nova", Gotham, Helvetica, sans-serif;
    font-weight: 400;
}
.image {
    border-radius: 5px;
    max-width: 100%;
    width: 100%;
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
    margin: 0px 0px 0px 0px;
}
.video {
    border-radius: 5px;
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
    max-width:100%;
    height:auto;
}
.image-mobile {
    border-radius: 5px;
    max-height: 400px;
    max-width: 100%;
    width: auto;
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
    margin-top: 10px;
}
.description {
    font-size: larger;
}
.social-feed-post-actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 7px 0px;
}
.post-action-button.like,
.post-action-button.share,{
    width: auto;
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 40px;
}
.mini-recipient {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.profile-img {
    margin-right: 12px;
}
@media only screen and (min-width: 1024px) and (max-width: 1366px) {
    .image-news-related {
        min-height: 200px;
        max-height: 200px;
    }
    .box-tags {
        width: 100%;
    }
    .box-related {
        margin: 30px auto 0;
        width: 95%;
    }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
    .image-news-related {
        min-height: 400px;
        max-height: 400px;
    }
    .box-tags {
        width: 100%;
    }
    .font-post-tag-related {
        font-size: 12px;
    }
    .title-post-related {
        font-size: 26px;
    }
    .margin-mobile {
        margin-top: 10px;
    }
    .box-related {
        margin: 30px auto 0;
        width: 95%;
    }
}
@media only screen and (max-width: 767px) {
    .image-news-related {
        min-height: 250px;
        max-height: 250px;
    }
    .box-tags {
        width: 100%;
    }
    .title-post-related {
        font-size: 22px;
    }
    .margin-mobile {
        margin-top: 10px;
    }
}
</style>
